import React from "react";
import {connect} from "react-redux";
import {Dimensions, FlatList, StyleSheet, View} from "react-native";
import ContactListItem from "../Contact/ContactListItem";
import TendancetListItem from "./TendancetListItem";

const {width,height} = Dimensions.get('screen');
class TendanceList extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isRefresh : false,
            data : this.props.data
        }
        this.renderItem = this.renderItem.bind(this);

    }
    _refresh(){
        this.setState({
            isRefresh:true,
            data : ()=>{this.props.refresh()}
        });
    }

    render() {

        const styles = StyleSheet.create({
            style:{
                flex:1,
                height:"100%",
                width:width
            }
        });


        // sort descending ("hotter" tendencies gets to the top)
        const data = this.props.data.sort((a, b) => a.total_counts < b.total_counts);
        return (
            <View style={{height:height-245,width:width,flex:1}}>
                <FlatList style={{width:width}}
                 refreshing={this.state.isRefresh} onRefresh={()=>{this._refresh();this.setState({isRefresh:false})}}
                 data={data}
                 keyExtractor={(item,index)=>index.toString()}
                 renderItem={(item)=>this.renderItem(item)} />
            </View>
        );
    }

    renderItem(item) {
      // DUCK typing
      const item_is_entity = item.item.link_target_type == "poi_entity";
      const is_entity = this.props.type === false ? item_is_entity  : this.props.type == 'Entity';
      const is_theme = this.props.type=='Theme';

      /*
      console.log("item is entity: ", item_is_entity);
      console.log("is entity: ", is_entity);
      console.log(item);
      */

      return <TendancetListItem
        isTheme={is_theme}
        isEntity={is_entity}
        refNavigation={this.props.refNavigation}
        isLink={this.props.isLink}
        type={is_theme ? "theme" : (is_entity ? "entity" : "contact")}
        isExplorer={this.props.isExplorer}
        isEntityScreen={this.props.isEntityScreen}
        avatar={this.props.avatar}
        item={item.item}
      />
    }

}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(TendanceList);

